import { render, staticRenderFns } from "./CustomerCampaign.vue?vue&type=template&id=4c9d13ad&"
import script from "./CustomerCampaign.vue?vue&type=script&lang=js&"
export * from "./CustomerCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports